import { useMemo } from 'react';
import type { PostmarkTemplateInput } from './types';
import {
  buildLocalPostmarkPreviewHtml,
  POSTMARK_PREVIEW_IFRAME_CLASS,
  POSTMARK_PREVIEW_PANEL_CLASS,
} from './postmarkTemplateLocalPreview';

interface PostmarkTemplatePreviewProps {
  template: PostmarkTemplateInput;
}

export default function PostmarkTemplatePreview({ template }: PostmarkTemplatePreviewProps) {
  const html = useMemo(() => buildLocalPostmarkPreviewHtml(template), [template]);
  const hasHtml = Boolean(template.htmlBody?.trim());

  return (
    <div className="space-y-3">
      <div className="text-xs text-gray-500 dark:text-gray-400 px-1">
        {hasHtml ? (
          <>
            <span className="font-medium text-gray-700 dark:text-gray-300">Local HTML preview</span>
            <span className="ml-2 text-gray-400">
              {template.templateType === 'Layout'
                ? '· sample content at {{{@content}}}'
                : template.layoutTemplate
                  ? `· inner template only (layout: ${template.layoutTemplate})`
                  : '· no API call'}
            </span>
          </>
        ) : null}
      </div>

      {!hasHtml ? (
        <p className="text-xs text-amber-700 dark:text-amber-300 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg px-3 py-2">
          Add HTML in the HTML body tab to preview.
        </p>
      ) : null}

      <div className={POSTMARK_PREVIEW_PANEL_CLASS}>
        {html ? (
          <iframe
            title="Postmark template preview"
            srcDoc={html}
            className={POSTMARK_PREVIEW_IFRAME_CLASS}
            sandbox="allow-same-origin"
          />
        ) : null}
      </div>
    </div>
  );
}
